import { Injectable, RendererFactory2 } from '@angular/core';
import { DomService, IAnalyticsWindow } from '@nibtravel/shared/util/dom';
import { Store } from '@ngxs/store';
import { AppConfigState } from '@nibtravel/shared/util/app-config';

export type CustomAttribute = { key: string; value: string };

@Injectable({
  providedIn: 'root',
})
export class NewRelicService {
  _window: IAnalyticsWindow;
  constructor(private _domService: DomService, private _store: Store) {
    this._window = this._domService.getAnalyticsWindow();
  }

  public init() {
    const newRelicScript = this._window.document.createElement('script');
    newRelicScript.type = 'text/java' + 'script';
    const newRelicScriptText = this._store.selectSnapshot((state) =>
      AppConfigState.getNewRelic(state.appConfig)
    ) as string;
    newRelicScript.innerHTML = newRelicScriptText;
    const script = this._window.document.getElementsByTagName('script')[0];
    // @ts-ignore
    script.parentNode.insertBefore(newRelicScript, script);
  }

  public setCustomAttribute(
    attributes: CustomAttribute | CustomAttribute[]
  ): void {
    if (Array.isArray(attributes)) {
      for (const attribute of attributes) {
        this._window.newrelic?.setCustomAttribute(
          attribute.key,
          attribute.value
        );
      }
    } else {
      this._window.newrelic?.setCustomAttribute(
        attributes.key,
        attributes.value
      );
    }
  }
}
